module.exports = __webpack_public_path__ + "public/img/horizontal_menu_logo.06511ee3.svg";